export const PAGE_NOT_FOUND = '/404';
export const DASHBOARD_URL = `/accounts/v1/account/dashboard`;
export const CONTACT_US_URL = 'EnvVar.CONTACT_US_URL.Link';
